import { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@zenbusiness/zui/styles';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import { Actions, FixedContainer } from './CtaContainer.style';

export default function CtaContainer({ children, marginBlockStart }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const containerRef = useRef(null);

  useEffect(() => {
    if (isMobile) {
      const containerHeight = containerRef.current?.clientHeight;
      document.body.style.paddingBottom = `${containerHeight}px`;
    } else {
      document.body.style.paddingBottom = 0; // reset padding after resize
    }

    return () => {
      document.body.style.paddingBottom = 0; // reset padding after unmount
    };
  }, [isMobile, theme]);

  if (isMobile) {
    return (
      <FixedContainer ref={containerRef}>
        <Actions>{children}</Actions>
      </FixedContainer>
    );
  }
  return <Actions marginBlockStart={marginBlockStart}>{children}</Actions>;
}

CtaContainer.propTypes = {
  marginBlockStart: PropTypes.number
};
